import React, {Component} from 'react';
import styled from 'styled-components';
import {P2, ValueTitle} from "../Kit/Kit";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  
  img{
    margin-bottom: 30px;
    width: 100%;
    cursor: pointer;
    
    :hover {
      filter: opacity(.6);
    }
  }
  
  h1{
    margin-bottom: 15px;
    cursor: pointer;
  }
`;

class TeamCard extends Component {
    render() {
        const {img, name, position, className, onClick} = this.props;
        return (
          <Container className={className}>
              <img
                src={img}
                alt="Team member img"
                onClick={onClick}
              />
              <ValueTitle onClick={onClick}>{name}</ValueTitle>
              <P2
                dangerouslySetInnerHTML={{__html: position}}
              />
          </Container>
        );
    }
};

export default TeamCard;



// WEBPACK FOOTER //
// ./src/components/GetToKnow/TeamCard.js